import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PROMOTE_HERO_FEED_AMOUNT_EXPERIMENT = defineFcm('promote_hero_feed_amount_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experiment_name: { type: 'string' },
				min_amount_in_usd: { type: 'number' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-front-end',
		context: 'Promote Page',
		description:
			'Controls the promote page HeroFeed amount experiment: the dynamic experiment name and the minimum amount (in USD) threshold used to deprioritize (push to the end of the list) promotions below it in variant_1.',
		import: false,
		template: {
			experiment_name: 'promote_hero_feed_amount_experiment',
			min_amount_in_usd: 10,
		},
	});
